import cn from 'classnames'
import Icon from '../../Common/Icon'
import styles from './TaskStatusGlyph.module.scss'

interface IProps {
  /**
   * complete → filled green disc with a check.
   * incomplete → outline ring around a muted check.
   */
  variant: 'complete' | 'incomplete'
  /** 'md' matches the task row; 'sm' sits inline in a run of text. */
  size?: 'sm' | 'md'
  /** Consumer-owned coloring for the incomplete variant, plus any
   *  hover/selected classes the caller drives from an ancestor. */
  className?: string
  /** Announced instead of being hidden. Omit when an ancestor button/link
   *  already carries the label. */
  label?: string
}

/**
 * What a task's status looks like. Shared so the task row, the detail panel, and
 * a rendered task-link chip can't drift into three different visual languages —
 * the glyph owns shape and sizing, the caller owns color and interaction.
 */
const TaskStatusGlyph = ({ variant, size = 'md', className, label }: IProps) => (
  <span
    className={cn(
      styles.glyph,
      size === 'sm' ? styles.sm : styles.md,
      {
        [styles.complete]: variant === 'complete',
        [styles.incomplete]: variant === 'incomplete',
      },
      className,
    )}
    role={label ? 'img' : undefined}
    aria-label={label}
    aria-hidden={label ? undefined : true}
  >
    <Icon name="check" size="xs" className={styles.check} />
  </span>
)

export default TaskStatusGlyph
